import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
    isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`
    }>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src="/siyarasoi-logo.jpg"
              alt="Siyarasoi Foundation Logo"
              className="h-14 w-14 sm:h-16 sm:w-16 object-contain rounded-full" />

            <div className="flex flex-col">
              <div className="text-xl sm:text-2xl font-bold !text-[#CEAE80]">
                Siyarasoi Foundation
              </div>
              <div className="text-xs sm:text-sm italic !text-[#CEAE80]">
                अन्नदान ही महादान
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="hover:text-teal-700 transition-colors font-medium !text-[#FF0000]">
              Home
            </button>
            <button onClick={() => scrollToSection('mission')} className="hover:text-teal-700 transition-colors font-medium !text-[#FF0000]">
              Mission
            </button>
            <button onClick={() => scrollToSection('impact')} className="hover:text-teal-700 transition-colors font-medium !text-[#FF0000]">
              Impact
            </button>
            <button onClick={() => scrollToSection('help')} className="hover:text-teal-700 transition-colors font-medium !text-[#FF0000]">
              How to Help
            </button>
            <Button onClick={() => scrollToSection('contact')} className="bg-teal-600 hover:bg-teal-700 text-white">
              Contact Us
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700 hover:text-teal-700 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>

            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen &&
        <div className="md:hidden bg-white border-t border-gray-200 py-4 space-y-3">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-teal-50 hover:text-teal-700 transition-colors font-medium">
              Home
            </button>
            <button onClick={() => scrollToSection('mission')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-teal-50 hover:text-teal-700 transition-colors font-medium">
              Mission
            </button>
            <button onClick={() => scrollToSection('impact')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-teal-50 hover:text-teal-700 transition-colors font-medium">
              Impact
            </button>
            <button onClick={() => scrollToSection('help')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-teal-50 hover:text-teal-700 transition-colors font-medium">
              How to Help
            </button>
            <div className="px-4 pt-2">
              <Button onClick={() => scrollToSection('contact')} className="w-full bg-teal-600 hover:bg-teal-700 text-white">
                Contact Us
              </Button>
            </div>
          </div>
        }
      </div>
    </header>);

};

export default Header;